import React, { useEffect, useState } from "react";
import { Save, Loader2, Plus, Trash2 } from "lucide-react";
import { fetchSettings, patchSettings, img } from "../../lib/api";
import { useSite } from "../../context/SiteContext";
import ImageUpload from "../ImageUpload";
import { toast } from "../../hooks/use-toast";

const input = "w-full bg-navy-700 border border-white/15 focus:border-gold rounded-lg px-3 py-2 text-white text-sm placeholder-slate-500 outline-none transition-colors";
const label = "block text-xs text-slate-400 mb-1.5";

const PaymentsPanel = () => {
  const { reload } = useSite();
  const [payments, setPayments] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { fetchSettings().then((s) => setPayments(s.payments || [])).catch(() => {}); }, []);
  if (!payments) return <div className="text-slate-400">Loading...</div>;

  const upd = (i, k, v) => setPayments((p) => p.map((x, idx) => (idx === i ? { ...x, [k]: v } : x)));
  const add = () => setPayments((p) => [...p, { id: "pay-" + Date.now(), name: "", address: "", logo: "" }]);
  const remove = (i) => setPayments((p) => p.filter((_, idx) => idx !== i));

  const save = async () => {
    setSaving(true);
    try { await patchSettings({ payments }); await reload(); toast({ title: "Saved", description: "Payment methods updated." }); }
    catch { toast({ title: "Error", description: "Could not save." }); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h3 className="text-white font-bold text-lg">Payment Methods</h3><p className="text-slate-400 text-sm">QR codes are generated automatically from each address.</p></div>
        <button onClick={add} className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy font-semibold px-4 py-2.5 rounded-xl transition-colors"><Plus size={16} /> Add Method</button>
      </div>
      <div className="space-y-4">
        {payments.map((p, i) => (
          <div key={p.id} className="bg-navy-800 rounded-2xl border border-white/10 p-5">
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-lg bg-navy-700 flex items-center justify-center shrink-0">{p.logo ? <img src={img(p.logo)} alt="" className="h-7 w-7" /> : <span className="text-slate-600 text-xs">logo</span>}</div>
              <div className="flex-1 grid sm:grid-cols-2 gap-3">
                <div><label className={label}>Method Name</label><input className={input} value={p.name} onChange={(e) => upd(i, "name", e.target.value)} placeholder="Bitcoin (BTC)" /></div>
                <div><label className={label}>Address / Tag</label><input className={input} value={p.address} onChange={(e) => upd(i, "address", e.target.value)} /></div>
                <div className="sm:col-span-2"><label className={label}>Logo</label><div className="flex items-center gap-3"><ImageUpload value={p.logo} onUpload={(url) => upd(i, "logo", url)} onClear={() => upd(i, "logo", "")} label="Upload logo" /><input className={`${input} flex-1`} value={p.logo || ""} onChange={(e) => upd(i, "logo", e.target.value)} placeholder="or paste a logo URL" /></div></div>
              </div>
              <button onClick={() => remove(i)} className="h-9 w-9 rounded-lg border border-white/15 text-slate-400 flex items-center justify-center hover:text-red-400 hover:border-red-400/40 transition-colors shrink-0"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} className="mt-6 inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy font-semibold px-6 py-3 rounded-xl transition-colors disabled:opacity-60">{saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Save Changes</button>
    </div>
  );
};

export default PaymentsPanel;
